import * as React from 'react';
import classNames from 'classnames';
import NvMarkdownInline from '../../NvMarkdownInline/NvMarkdownInline.esm.js';
import NvHeading from '../../NvHeading/NvHeading.esm.js';
import NvMarkdown from '../../NvMarkdown/NvMarkdown.esm.js';
import NvSubheading from '../../NvSubheading/NvSubheading.esm.js';

var tabsBlockAlignMap = {
    center: 'textCenter',
    left: 'left',
    right: 'right',
};
var NvTabsTextContent = function (_a) {
    var heading = _a.heading, subheading = _a.subheading, body = _a.body, alignment = _a.alignment;
    if (!heading && !subheading && !body)
        return null;
    return (React.createElement("div", { className: "nv-tabs-text-content" },
        !!heading && (React.createElement(NvMarkdownInline, { className: classNames('heading', alignment && tabsBlockAlignMap[alignment]), element: "h1", elementWrapper: NvHeading, level: 1 }, heading)),
        !!subheading && (React.createElement(NvMarkdownInline, { className: classNames('subheading', alignment && tabsBlockAlignMap[alignment]), elementWrapper: NvSubheading, level: "level1book" }, subheading)),
        !!body && React.createElement(NvMarkdown, { className: alignment && tabsBlockAlignMap[alignment] }, body)));
};

export { NvTabsTextContent };
//# sourceMappingURL=NvTabsTextContent.esm.js.map
